/* eslint-disable jira/filename-case */
import { performDeleteRequest } from '@atlassian/jira-fetch/src/index.tsx';

type IssueTypeId = string;
type ProjectId = string;

export const performDeleteIssueType = (
	issueTypeId: IssueTypeId,
	projectId: ProjectId,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
	return performDeleteRequest(
		`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}`,
	);
};
